import { z } from 'zod'

export const PASSWORD_MIN_CHARS = 12
export const PASSWORD_MAX_CHARS = 128
export const GENERATED_PASSWORD_LENGTH = 16
export const PASSWORD_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'

const BYTE_VALUES = 256
const UNBIASED_LIMIT = BYTE_VALUES - (BYTE_VALUES % PASSWORD_ALPHABET.length)

export type RandomFill = (buffer: Uint8Array<ArrayBuffer>) => Uint8Array

const secureFill: RandomFill = (buffer) => globalThis.crypto.getRandomValues(buffer)

const unbiasedChars = (bytes: Uint8Array): string[] =>
  [...bytes].filter((byte) => byte < UNBIASED_LIMIT).map((byte) => PASSWORD_ALPHABET.charAt(byte % PASSWORD_ALPHABET.length))

const draw = (fill: RandomFill, sofar: string): string => {
  if (sofar.length >= GENERATED_PASSWORD_LENGTH) return sofar.slice(0, GENERATED_PASSWORD_LENGTH)
  const bytes = fill(new Uint8Array(GENERATED_PASSWORD_LENGTH - sofar.length))
  return draw(fill, sofar + unbiasedChars(bytes).join(''))
}

export const generatePassword = (fill: RandomFill = secureFill): string => draw(fill, '')

export const NewPassword = z
  .string()
  .min(PASSWORD_MIN_CHARS)
  .max(PASSWORD_MAX_CHARS)
  .refine((value) => value.trim() !== '', { message: 'must not be blank' })
